import { ZoneOccupationResponseDTO } from '@core/api/dtos/response/zone/occupation'
import { Occupation } from '@core/api/entities/zone/occupation'

export class OccupationMapper {
	static toEntity(dto: ZoneOccupationResponseDTO): Occupation {
		return Occupation.create({
			since: dto.since,
			occupation: dto.occupation,
		})
	}

	static toEntities(dtos: ZoneOccupationResponseDTO[]): Occupation[] {
		return dtos.map(this.toEntity)
	}
}
